var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNicotinePouches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3494_13565)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4402 49.5C78.4402 42.3513 79.4317 37.6384 79.4406 37.5944L80 35L77.3126 35.3613C77.214 35.3736 67.2781 36.6814 50.5009 36.6814C33.7237 36.6814 23.786 35.3736 23.6892 35.3613L21 35L21.5594 37.5944C21.5701 37.6402 22.5598 42.3161 22.5598 49.5C22.5598 56.6839 21.5683 61.3598 21.5594 61.4056L21 64L23.6874 63.6405C23.786 63.6264 33.7219 62.3203 50.4991 62.3203C67.2763 62.3203 77.2122 63.6264 77.3108 63.6405L79.9946 63.9982L79.4406 61.4074C79.4299 61.3616 78.4402 56.6487 78.4402 49.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8168 60.7783C70.0785 60.0574 71.4787 55.8715 71.4787 48.566C71.4787 41.2605 70.1233 38.1831 69.8311 37.5786C65.2486 37.8994 58.7031 38.2096 50.5009 38.2096C42.2987 38.2096 35.7549 37.8994 31.1707 37.5786C30.8784 38.1831 29.5231 41.375 29.5231 48.566C29.5231 55.7569 30.9215 60.0574 31.1832 60.7783C35.7657 60.4575 42.3059 60.1473 50.4991 60.1473C58.6923 60.1473 65.2325 60.4575 69.8168 60.7783Z",
    fill: "#D8DFE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3494_13565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 29,
    fill: "white",
    transform: "translate(21 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNicotinePouches);
export default __webpack_public_path__ + "static/media/nicotine_pouches.8f21cfd7065ee80c4325f64901dc74ad.svg";
export { ForwardRef as ReactComponent };